import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: relative;
	width: 400px;
	z-index: 3;

	&:hover {
		img {
			filter: invert(100%);
			opacity: 1;
		}
	}
`;

const StyledIcon = styled.img`
	position: absolute;
	top: 50%;
	right: 20px;
	width: 14px;
	height: 14px;
	opacity: 0.25;
	transform: translateY(-50%);
	transition:
		filter 0.3s ease,
		opacity 0.3s ease;
	user-select: none;
	pointer-events: none;
`;

const StyledInput = styled.input`
	width: 100%;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.1);
	padding: 17px 54px 17px 20px;
	border: 0;

	color: #ffffff;
	font-family: GT Walsheim Pro;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;

	transition: all 0.3s ease;

	&::placeholder {
		color: rgba(255, 255, 255, 0.5);
	}

	&:focus {
		outline: none;
	}

	&:hover,
	&:active,
	&:focus {
		background-color: rgba(255, 255, 255, 1);
		color: #000000;

		& + img {
			filter: invert(100%);
			opacity: 1;
		}

		&::placeholder {
			color: rgba(0, 0, 0, 0.25);
		}
	}

	&::placeholder {
		color: rgba(255, 255, 255, 0.26);
	}
`;

const StyledResultsContainer = styled.div`
	position: absolute;
	top: calc(100% + 10px);
	display: flex;
	flex-direction: column;
	width: 100%;
	max-height: 320px;
	border-radius: 10px;
	background: #ffffff;
	overflow-y: auto;
	z-index: 2;

	transition: opacity 0.3s ease;

	&.results-enter {
		opacity: 0;
	}

	&.results-enter-active,
	&.results-enter-done,
	&.results-exit {
		opacity: 1;
	}

	&.results-exit-active {
		opacity: 0;
	}

	&::-webkit-scrollbar {
		width: 10px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: rgba(0, 0, 0, 0.25);
		transition: background-color 0.3s ease;

		&:hover {
			background-color: rgba(0, 0, 0, 1);
		}
	}
`;

const StyledSelectItem = styled.div.attrs({ className: 'item' })`
	display: grid;
	grid-template-columns: 20px 1fr auto;
	column-gap: 20px;
	padding: 20px 0;
	border-bottom: 1px solid rgba(0, 0, 0, 0.1);

	img {
		filter: invert(100%);
		transition: filter 0.3s ease;
	}
`;

const StyledSelectItemWrapper = styled.div<{ $disabled?: boolean }>`
	padding: 0 20px;
	background-color: transparent;
	transition: background-color 0.3s ease;

	${(props) =>
		!props.$disabled &&
		css`
			&:hover {
				background-color: #000000;

				${StyledSelectItem} {
					img {
						filter: invert(0);
					}

					& ${Text}:nth-child(2) {
						color: #ffffff;
					}

					& ${Text}:nth-child(3) {
						color: rgba(255, 255, 255, 0.5);
					}
				}
			}
		`}

	${StyledSelectItem} {
		& ${Text}:nth-child(2) {
			color: #000000;
			transition: color 0.3s ease;

			${(props) =>
				!props.$disabled &&
				css`
					cursor: pointer;
				`}
		}

		& ${Text}:nth-child(3) {
			color: transparent;
			transition: color 0.3s ease;

			${(props) =>
				!props.$disabled &&
				css`
					cursor: pointer;
				`}
		}

		${(props) =>
			!props.$disabled &&
			css`
				cursor: pointer;
			`}
	}
`;

export {
	StyledContainer,
	StyledIcon,
	StyledInput,
	StyledResultsContainer,
	StyledSelectItem,
	StyledSelectItemWrapper,
};
